import { CsI18n } from "../shared/csI18n/csI18n";
import TooltipHelper from "./TooltipHelper";
import { Heading } from "@shopify/polaris";
import React from "react";

const HeadingHelper = {
  h3: (title) => {
    return (
      <Heading element='h3'>
        {CsI18n.t(title)}
      </Heading>
    );
  },

  h3tt: (title, tooltipDesc) => {
    return (
      <Heading element='h3'>
        {HeadingHelper._labelWithTooltip(title, tooltipDesc)}
      </Heading>
    );
  },

  l: (label) => {
    return CsI18n.t(label);
  },

  ltt: (label, tooltipDesc) => {
    return HeadingHelper._labelWithTooltip(label, tooltipDesc);
  },

  ptt: (label, tooltipDesc) => {
    return <p>{HeadingHelper._labelWithTooltip(label, tooltipDesc)}</p>;
  },

  _labelWithTooltip: (label, tooltipDesc) => {
    return (
      <>
        {CsI18n.t(label)}
        {TooltipHelper.lightT(tooltipDesc)}
      </>
    );
  },
}

export default HeadingHelper;